<template>
  <div>
    <LWMSTile :baseUrl="baseUrl" :params="params"></LWMSTile>
  </div>
</template>

<script>
import { LWMSTile, OMapMixin } from '@OpenLayersCommon';

export default {
    name: 'WaterRoad',
    mixins: [OMapMixin],
    components: {
        LWMSTile,
    },
    props: {
        baseUrl: {
            type: String,
            dafault: '',
        },
        params: {
            type: Object,
            dafault () {
                return {};
            },
        },
    },
    data () {
        return {

        };
    },
    methods: {
        async getM () {
            const map = await this.$parent.getMap();
            console.log(map);
        },
    },
    mounted () {
        this.getM();
    },
};
</script>

<style lang="scss" scoped>

</style>
